module.exports = __webpack_public_path__ + "img/multi_robo.5793703e.svg";